module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/kaya_icon.jpg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"b8bde9166afe6d412c36f96c75070906"},
    },{
      plugin: require('../node_modules/gatsby-plugin-prismic-previews/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"kaya","accessToken":"MC5aQUhsQnhBQUFDa0FPa2xB.Xu-_vVlW77-977-9f--_vWXvv70zV--_ve-_ve-_vTnvv70977-9Zu-_ve-_ve-_ve-_ve-_vTpW77-977-9WO-_vT0"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
